import { required, email, minLength } from 'vuelidate/lib/validators'
import { isValidPhoneNumber } from 'libphonenumber-js'
import countries from '@/data/miscData/countries'

const formData = {
  specialPatient: {
    name: {
      size: 8,
      type: 'text',
      name: 'specialPatient.name',
      label: 'Nome completo:',
      placeholder: 'Digite o nome completo',
      value: null
    },
    email: {
      size: 4,
      type: 'text',
      name: 'specialPatient.email',
      label: 'E-mail:',
      placeholder: 'Digite o e-mail',
      value: null
    },
    ddiContactPhone: {
      size: 2,
      type: 'select',
      name: 'specialPatient.ddiContactPhone',
      label: 'DDI:',
      value: null,
      options: countries
    },
    contactPhone: {
      size: 4,
      type: 'text',
      name: 'specialPatient.contactPhone',
      label: 'Telefone:',
      mask: ['(##) ####-####', '(##) #####-####'],
      placeholder: 'Digite o número de telefone',
      value: null
    },
    gender: {
      size: 4,
      type: 'radio',
      name: 'specialPatient.gender',
      label: 'Sexo:',
      radios: [
        {
          label: 'Feminino',
          value: 'F'
        },
        {
          label: 'Masculino',
          value: 'M'
        }
      ],
      value: null
    },
    cpf: {
      size: 4,
      type: 'text',
      name: 'specialPatient.cpf',
      label: 'CPF:',
      placeholder: 'Digite o CPF',
      mask: '###.###.###-##',
      value: null,
      errors: {
        isValidCpf: 'CPF inválido'
      }
    },
    rg: {
      size: 4,
      type: 'text',
      name: 'specialPatient.rg',
      label: 'RG:',
      placeholder: 'Digite o RG',
      maxlength: 15,
      value: null
    },
    dateOfBirth: {
      size: 4,
      type: 'text',
      name: 'specialPatient.dateOfBirth',
      mask: '##/##/####',
      label: 'Data de nascimento:',
      placeholder: '  /  /',
      value: null
    }
    // nationalHealthCard: {
    //   size: 4,
    //   type: 'text',
    //   name: 'specialPatient.nationalHealthCard',
    //   label: 'Cartão nacional de saúde:',
    //   mask: '######################',
    //   classes: ['flex-column', 'flex-nowrap'],
    //   placeholder: 'Digite o nº',
    //   value: null
    // }
  },
  address: {
    cep: {
      size: 3,
      type: 'text',
      name: 'address.cep',
      label: 'CEP:',
      placeholder: 'CEP',
      mask: '#####-###',
      value: null
    },
    street: {
      size: 6,
      type: 'text',
      name: 'address.street',
      label: 'RUA:',
      placeholder: 'Rua',
      value: null,
      disabled: false
    },
    number: {
      size: 3,
      type: 'text',
      name: 'address.number',
      label: 'NÚMERO:',
      placeholder: 'N.',
      value: null
    },
    complement: {
      size: 3,
      type: 'text',
      name: 'address.complement',
      label: 'COMPLEMENTO:',
      placeholder: 'Ap., conj.',
      value: null
    },
    district: {
      size: 3,
      type: 'text',
      name: 'address.district',
      label: 'BAIRRO:',
      placeholder: 'Bairro',
      value: null,
      disabled: false
    },
    city: {
      size: 4,
      type: 'text',
      name: 'address.city.name',
      label: 'CIDADE:',
      placeholder: 'Cidade',
      value: null,
      disabled: false
    },
    uf: {
      size: 2,
      type: 'text',
      name: 'address.uf',
      label: 'UF:',
      placeholder: 'UF',
      value: null,
      disabled: false
    },
    latitude: {
      type: 'hidden',
      hide: true,
      name: 'address.latitude',
      value: null
    },
    longitude: {
      type: 'hidden',
      hide: true,
      name: 'address.longitude',
      value: null
    }
  },
  creditCard: {
    holderName: {
      size: 12,
      type: 'text',
      name: 'holderName',
      label: 'NOME DO PORTADOR:',
      placeholder: 'Digite conforme consta no cartão',
      value: ''
    },
    number: {
      size: 6,
      type: 'text',
      name: 'number',
      label: 'NÚMERO DO CARTÃO:',
      placeholder: 'Digite o número do seu cartão',
      mask: '#### #### #### ####',
      value: false
    },
    expirationDate: {
      size: 4,
      type: 'text',
      name: 'expirationDate',
      label: 'DATA DE VENCIMENTO:',
      mask: '##/##',
      placeholder: 'MM/AA',
      value: null
    },
    cvv: {
      size: 2,
      type: 'text',
      name: 'cvv',
      label: 'CVV:',
      mask: '###',
      value: null
    }
    // installments: {
    //   size: 4,
    //   type: 'select',
    //   name: 'installments',
    //   label: 'PARCELAS:',
    //   value: 1,
    //   options: [
    //     {
    //       id: 1,
    //       name: 1
    //     },
    //     {
    //       id: 2,
    //       name: 2
    //     },
    //     {
    //       id: 3,
    //       name: 3
    //     },
    //     {
    //       id: 4,
    //       name: 4
    //     },
    //     {
    //       id: 5,
    //       name: 5
    //     },
    //     {
    //       id: 6,
    //       name: 6
    //     },
    //     {
    //       id: 7,
    //       name: 7
    //     },
    //     {
    //       id: 8,
    //       name: 8
    //     },
    //     {
    //       id: 9,
    //       name: 9
    //     },
    //     {
    //       id: 10,
    //       name: 10
    //     }
    //   ]
    // }
  }
}

const validations = {
  specialPatient: {
    name: {
      value: { required }
    },
    email: {
      value: {
        email,
        required
      }
    },
    ddiContactPhone: {
      value: { required }
    },
    contactPhone: {
      value: {
        required,
        isValid (value) {
          if (value) {
            const iso = this.formData.specialPatient.ddiContactPhone.value
            return isValidPhoneNumber(value, String(iso.toUpperCase()))
          }

          return true
        }
      }
    },
    cpf: {
      value: {
        required,
        isValid (value) {
          return this.fn_VALID_CPF(value)
        }
      }
    },
    dateOfBirth: {
      value: {
        required,
        isValidDate (value) {
          if (value) {
            const date = this.$moment(value, 'DD/MM/YYYY', true)
            return date.isValid()
          }
          return true
        }
      }
    },
    rg: {
      value: {
        required,
        isValid (value) {
          if (value) {
            const onlyDigits = value.replace(/\D/gi, '')
            return !/^[^1-9]+$/gi.test(onlyDigits)
          }

          return true
        }
      }
    }
  },
  creditCard: {
    holderName: {
      value: {
        required
      }
    },
    number: {
      value: {
        required
      }
    },
    expirationDate: {
      value: {
        required,
        isValidDate (value) {
          const date = this.$moment(value, 'MM/YY', true)
          return date.isValid() && date.isAfter(this.$moment(), 'm')
        }
      }
    },
    cvv: {
      value: {
        required,
        minLength: minLength(3)
      }
    }
  },
  address: {
    cep: {
      value: {
        required,
        isValid (value) {
          if (value) {
            const regex = /(\d){5}-(\d){3}/
            return regex.test(value)
          }

          return true
        }
      }
    },
    city: { value: { required } },
    uf: { value: required },
    district: { value: required },
    street: { value: required },
    number: { value: required }
  }
}

export { formData, validations }
